"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostOrderDelete = void 0;
const Base_1 = require("./Base");
exports.PostOrderDelete = {
    url: Base_1.URL_BASE + "/OrderDelete",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostOrderDelete.js.map